//开发配置
const dev = {
  //  url: "http://192.168.1.95:8081/",//
  //  url:'http://nocs.herocheer.com/sports/sys/api/'
  //  url:'http://ijs.sports.xm.gov.cn'
   url:'http://ijs.sports.xm.gov.cn/sports/sys/api/'
}

//正式生产配置
const prod = {
  //  url: "http://nocs.herocheer.com/sports/sys/api/",
  url:'http://ijs.sports.xm.gov.cn/sports/sys/api/'
}
let NEW_API={};
if(process.env.NODE_ENV === 'production'){
  NEW_API=prod;
}else{
  NEW_API=dev
}
module.exports = NEW_API



// WEBPACK FOOTER //
// ./src/webpackApi.js